import React, { FC } from 'react';
import openLink from 'libs/open-link';
import './index.scss';

interface IAddressInfoProps {
    name: String;
    tel: String;
    address: String;
    canChoose: boolean;
    isLower: boolean;
}

const AddressInfo: FC<IAddressInfoProps> = ({
    name = '',
    tel = '',
    address = '',
    canChoose = false,
    isLower = false
}) => {
    // 这个逻辑永远不会执行
    const gotoAddressSelector = () => {
        if (!canChoose) return;
        openLink('/views/address/list', { title: '地址列表', control: true });
    };
    return (
        <div className="address-container" onClick={gotoAddressSelector}>
            <i className="address-info-location"></i>
            <div className="address-info">
                <div className="address-info-head">
                    <div
                        className={`address-info-name ${isLower ? 'address-info-name__lower' : ''}`}
                    >
                        {name}
                    </div>
                    <div className="address-info-tel">{tel}</div>
                </div>
                <div
                    className={`address-info-bottom ${isLower ? 'address-info-bottom__lower' : ''}`}
                >
                    {address}
                </div>
            </div>
            {canChoose && <i className="address-info-arrow"></i>}
        </div>
    );
};

export default AddressInfo;
